import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import type { ConsentScope } from '../types';

interface ConsentScopesProps {
  scopes: ConsentScope[];
}

export function ConsentScopes({ scopes }: ConsentScopesProps) {
  if (!scopes.length) {
    return null;
  }

  return (
    <div className='flex flex-col gap-1.5 w-[352px] max-w-full'>
      {scopes.map(scope => (
        <div
          key={scope.scope}
          data-testid={`consent-scope-${scope.scope}`}
          data-already-granted={scope.already_granted}
          className='flex flex-col p-3 rounded-xl border border-secondary bg-primary'
        >
          <Text
            size={TextSizes.SM}
            weight={FontWeights.MEDIUM}
            className='leading-5 text-primary'
          >
            {scope.title}
          </Text>
          <Text
            size={TextSizes.XS}
            weight={FontWeights.REGULAR}
            className='leading-[18px] text-secondary mt-0.5'
          >
            {scope.description}
            {scope.already_granted && ' (already allowed)'}
          </Text>
        </div>
      ))}
    </div>
  );
}
